export const ROOT_ID = 'cb-bookingengine';
export const ROOT_CLASSNAME = 'cb-bookingengine-root';
export const ROOT_SELECTOR = `#${ROOT_ID}`;
export const MAIN_LAYOUT_SELECTOR = `#cb-bookingengine-main-layout`;
/**
 * The Immersive Experience popup's card — the flex column holding the popup
 * header and its scrolling body. Anything that must stay put while the guest
 * scrolls the popup has to live here, outside the scrolling body.
 */
export const POPUP_CONTENT_CLASSNAME = 'cb-immersive-experience-popup-content';
export const POPUP_CONTENT_SELECTOR = `.${POPUP_CONTENT_CLASSNAME}`;
export const getRootElement = () => document.getElementById(ROOT_ID);
export const getMainLayoutElement = () => document.querySelector(MAIN_LAYOUT_SELECTOR);
export const getPopupContentElement = () => document.querySelector(POPUP_CONTENT_SELECTOR);
